import React from "react";

export const feedFilterTypes = [
  {
    label: "All",
    key: "all",
  },
  {
    label: "Company",
    key: "company",
  },
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedLimitedFilterTypes = [
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedTypes = [
  "company update",
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
  // 'question',
  // 'incident reporting',
  // 'meeting',
  // 'task checklist',
  // 'polls/pulse survey',
];

export const managerFeedTypes = [
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
];

export const employeeFeedTypes = [
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
];

export const feedKudosTypes = [
  {
    label: "Employee of the month",
    key: "employee_of_the_month",
    points: 2,
  },
  {
    label: "Congratulations",
    key: "congratulations",
    points: 1,
  },
  {
    label: "You're a star",
    key: "star",
    points: 1,
  },
  {
    label: "Thank you",
    key: "thank_you",
    points: 1,
  },
  {
    label: "Work Anniversary",
    key: "work_anniversary",
    points: 1,
  },
  // {
  //   label: "Happy Birthday",
  //   key: "happy_birthday",
  //   points: 1,
  // },
];

/** Predefined recognition values (submitted as kudos_value[0] / kudos_value[1]). */
export const feedKudosValues = [
  { label: "Compassion", key: "compassion" },
  { label: "Teamwork", key: "teamwork" },
  { label: "Excellence", key: "excellence" },
  { label: "Integrity", key: "integrity" },
  { label: "Respect", key: "respect" },
  { label: "Innovation", key: "innovation" },
];

export const getKudosValuesFromFeed = (data) => {
  const v = data?.values ?? data?.kudos_value;
  if (Array.isArray(v)) {
    return v
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean)
      .slice(0, 2);
  }
  if (v && typeof v === "object") {
    const nums = Object.keys(v)
      .filter((k) => /^\d+$/.test(String(k)))
      .sort((a, b) => Number(a) - Number(b));
    const ordered = nums.length ? nums.map((k) => v[k]) : Object.values(v);
    return ordered
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean)
      .slice(0, 2);
  }
  const slots = [
    data?.value_0,
    data?.value_1,
    data?.values_0,
    data?.values_1,
    data?.kudos_value_0,
    data?.kudos_value_1,
  ]
    .map((x) => (x == null ? "" : String(x).trim()))
    .filter(Boolean);
  return slots.slice(0, 2);
};

export const resetTypeSpecificFields = ({ previousType, nextType }) => {
  const patch = {};

  if (previousType === nextType) {
    return patch;
  }

  if (previousType === "kudos" && nextType !== "kudos") {
    patch.kudos_type = "";
    patch.kudos_value_0 = "";
    patch.kudos_value_1 = "";
  }

  if (previousType === "event" && nextType !== "event") {
    patch.event_date = "";
    patch.event_start_time = "";
    patch.event_end_time = "";
    patch.event_location = "";
  }

  if (previousType === "poll" && nextType !== "poll") {
    patch.poll_type = "text";
    patch.question = "";
    patch.options = [];
    patch.allow_multiple = false;
    patch.show_results_after_vote = false;
    patch.expires_at = "";
  }

  if (nextType === "kudos" && !patch.kudos_type) {
    patch.kudos_type = "congratulations";
  }

  patch.is_acknowledgement_required = nextType === "priority";

  return patch;
};

export const feedToAdminTypes = ["company", "location", "employee", "team"];

export const feedToTypes = ["location", "employee", "team"];

export const feedStringKeys = [
  "target",
  "title",
  "description",
  "feed_type",
  "kudos_type",
  "is_acknowledgement_required",
  "is_comment_disabled",
  "is_reaction_disabled",
  "event_date",
  "event_start_time",
  "event_end_time",
  "event_location",
];

export const reactionTypes = ["like"];

export const reactionIcons = {
  like: "👍",
};

export const feedPollTypes = ["text", "image"];

export const formatFeedVotes = (votes) => {
  // Handle empty array, null, or undefined
  if (!votes || !Array.isArray(votes) || votes.length === 0) {
    return [];
  }

  const formattedVotes = votes.map((vote) => {
    const votedEmployees = vote.voted_employees || [];

    return {
      ...vote,
      display_list: votedEmployees.slice(0, 5),
      all_list: votedEmployees,
    };
  });

  return formattedVotes;
};
